// frontend/src/pages/AdminDashboard.jsx
import React from 'react';
import { ChartBarIcon } from '@heroicons/react/24/outline';

const AdminDashboard = () => {
  return (
    <div className="space-y-6">
      <div className="flex items-center space-x-3">
        <div className="flex justify-center items-center w-10 h-10 bg-red-100 rounded-lg">
          <ChartBarIcon className="w-6 h-6 text-red-600" />
        </div>
        <h1 className="text-2xl font-bold text-gray-900">Admin Dashboard</h1>
      </div>
      <div className="card">
        <div className="card-content">
          <p className="text-gray-600">Admin dashboard coming soon...</p>
        </div>
      </div>
    </div>
  );
};

export default AdminDashboard;